import axiosInstance from '../../Helpers/api_helper';

export const getUserProfile = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get('api/v1/participants/me');
    return response.data;
  } catch (error: any) {
    console.error('Error getting user profile:', error.message);
    throw error;
  }
};